import { Languages } from 'config';

const CONFIGURATION = {};

export default CONFIGURATION;

export const Translations = {
  match: {
    [Languages.Greek]: 'Match Payment',
    [Languages.English]: 'Match Payment',
  },
  vat_returns: {
    [Languages.Greek]: 'VAT Returns',
    [Languages.English]: 'VAT Returns',
  },
  match_payment: {
    [Languages.Greek]: 'Match',
    [Languages.English]: 'Match',
  },
};
